import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getCreatorInfo } from '../../../store/actions';

import * as S from './style';

interface AuthorProps {
    creator: string;
}

let i = 0;

const Author: React.FC<AuthorProps> = ({ creator }) => {
    const dispatch = useAppDispatch();
    const { creators } = useAppSelector(state => state.creator);
    const user = creators.find(user => user.username === creator);

    useEffect(() => {  
        while (i <= creators.length) {
            if (user && user.username === creator) {
                return 
            } else {
                dispatch(getCreatorInfo(creator));
            }

            i++;
        }
    }, [dispatch, creator, creators.length, user])

    return (
        <S.AuthorWrapper>
            <S.Author>
                Di: <Link to={`/author/${creator}`}>{user && user.fullname}</Link>
            </S.Author>
        </S.AuthorWrapper>
    )
}

export default Author;